import { render, staticRenderFns } from "./RecordingServer.vue?vue&type=template&id=1f58992b&scoped=true"
import script from "./RecordingServer.vue?vue&type=script&lang=js"
export * from "./RecordingServer.vue?vue&type=script&lang=js"
import style0 from "./RecordingServer.vue?vue&type=style&index=0&id=1f58992b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f58992b",
  null
  
)

export default component.exports